import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getGroupId = (state: ContentPluginRootState) => state.data.activeGroup?.id;

export default getGroupId;
